import { FC } from 'react';

import { Grid } from '@purpur/library';

import HtmlContent from '@telialt/common-html-content/src';

import { DescriptionContainer } from './CategoryDescription.styles';

type Props = {
    description: string;
};

export const CategoryDescription: FC<Props> = ({ description }) => {
    return (
        <DescriptionContainer>
            <Grid>
                <HtmlContent content={description} />
            </Grid>
        </DescriptionContainer>
    );
};
